"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function Philosophy() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.18,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.21, 0.47, 0.32, 0.98]
      }
    }
  };
  const paragraphs = [<>We believe beautiful spaces begin with balance, proportion, and a respect for architecture and history but what makes them memorable is soul. We create interiors that feel like sanctuaries rather than showpieces: comfortable, collected, and designed to be lived in.<div><br /></div><div>Our approach pairs enduring design with a contemporary point of view, combining natural materials, distinctive furnishings and carefully considered details to create spaces with warmth, character, and lasting appeal. To us, luxury is not defined by trends, but by comfort, craftsmanship and a sense of home that feels uniquely personal.</div></>];
  return <section id="philosophyprocess" data-nav="light" className="relative bg-background text-foreground overflow-hidden ![padding:0px_32px_0px_32px]">
      <div className="mx-auto max-w-2xl">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} className="flex flex-col items-center text-center">
          <motion.div variants={itemVariants} className="mb-10 sm:mb-12">
            <span className="text-[11px] font-default uppercase tracking-[0.22em] text-muted-foreground font-medium select-none">
              PHILOSOPHY AND PROCESS
            </span>
          </motion.div>

          <div className="space-y-6 sm:space-y-8 text-justify font-serif text-lg sm:text-xl lg:text-[22px] leading-relaxed text-foreground/90">
            {paragraphs.map((paragraph, index) => <motion.p key={index} data-index={index} variants={itemVariants} className="tracking-normal">
                {paragraph}
              </motion.p>)}
          </div>

          <motion.div variants={itemVariants} className="mt-12 sm:mt-16 w-12 h-px bg-border" aria-hidden="true" />
        </motion.div>
      </div>
    </section>;
}